/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PlatformKillswitchesNumberListDefinitionsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type PlatformKillswitchesNumberListDefinitionsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type PlatformKillswitchesNumberListDefinitionsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberListDefinitionsSecurity$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberListDefinitionsSecurity$Outbound,
    PlatformKillswitchesNumberListDefinitionsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberListDefinitionsSecurityToJSON(
  platformKillswitchesNumberListDefinitionsSecurity:
    PlatformKillswitchesNumberListDefinitionsSecurity,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberListDefinitionsSecurity$outboundSchema.parse(
      platformKillswitchesNumberListDefinitionsSecurity,
    ),
  );
}

/** @internal */
export type PlatformKillswitchesNumberListDefinitionsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const PlatformKillswitchesNumberListDefinitionsRequest$outboundSchema:
  z.ZodMiniType<
    PlatformKillswitchesNumberListDefinitionsRequest$Outbound,
    PlatformKillswitchesNumberListDefinitionsRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function platformKillswitchesNumberListDefinitionsRequestToJSON(
  platformKillswitchesNumberListDefinitionsRequest:
    PlatformKillswitchesNumberListDefinitionsRequest,
): string {
  return JSON.stringify(
    PlatformKillswitchesNumberListDefinitionsRequest$outboundSchema.parse(
      platformKillswitchesNumberListDefinitionsRequest,
    ),
  );
}
